import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");
const fmt = (ms) => {
  const s = Math.floor(ms / 1000);
  return `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
};
const SOS_MS = 3 * 3600 * 1000;

export const isSos = (ride) => {
  const left = new Date(ride.pickup_at).getTime() - Date.now();
  return ride.status === "available" && left > 0 && left <= SOS_MS;
};

export const RideFlags = ({ ride }) => {
  const [now, setNow] = useState(Date.now());
  const left = new Date(ride.pickup_at).getTime() - now;
  const sos = left > 0 && left <= SOS_MS;

  useEffect(() => {
    if (!sos) {
      return undefined;
    }
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, [sos]);

  if (!sos && !ride.boosted) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 -mb-1">
      {sos && (
        <span data-testid="ride-last-minute-badge" className="ff-badge ff-sos-badge text-white font-extrabold text-sm">
          🚨 SOS / LAST MINUTE <span data-testid="ride-countdown" className="ff-code">{fmt(left)}</span>
        </span>
      )}
      {ride.boosted && <span data-testid="ride-boosted-badge" className="ff-badge bg-amber-400 border-amber-400 text-black font-extrabold text-sm">⚡ IN CIMA</span>}
    </div>
  );
};
